import React from 'react';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import {
  myWalletAddCcButtonClicked,
  myWalletModalClosed,
  myWalletModalStartedLoading,
  myWalletNewCcWasAdded,
} from '@wix/bi-logger-cashier-ugc/v2';
import { wixSdkAdapter } from '../../utils/wixSdkAdapter';
import { getBiLogger } from '../../utils/biLogger';
import { getAddPaymentMethodUrl } from '../../utils/links';
import { InteractionName } from '../../types/InteractionName';
import { fedopsLogger } from '../../utils/fedopsLogger';
import { ModalType } from '../../types/ModalType';
import { AddPaymentMethodButtonView } from './view';
import { AddPaymentMethodButtonConnectedProps } from './controller.connect';

const MODAL_SIZE = {
  [DeviceType.Desktop]: {
    width: 583,
    height: 508,
  },
  // workaround to open modal to 100%, openModal doesn't support string values
  // https://wix.slack.com/archives/CAKBA7TDH/p1604926273350300?thread_ts=1604922926.343800&cid=CAKBA7TDH
  [DeviceType.Mobile]: {
    width: 2000,
    height: 2000,
  },
};

export const AddPaymentMethodButtonController: React.FC<AddPaymentMethodButtonConnectedProps> = (props) => {
  const openAddNewModal = React.useCallback(() => {
    getBiLogger().report(myWalletAddCcButtonClicked({}));
    if (props.viewMode !== 'site' || !window) {
      return;
    }

    getBiLogger().report(myWalletModalStartedLoading({ modalType: ModalType.AddingCC }));
    fedopsLogger.interactionStarted(InteractionName.LOAD_ADD_PM_MODAL);

    wixSdkAdapter.openModal({
      url: getAddPaymentMethodUrl({ startLoadTime: Date.now(), appSessionId: props.appSessionId }),
      width: MODAL_SIZE[props.deviceType].width,
      height: MODAL_SIZE[props.deviceType].height,
      onClose: async (data: { message: { paymentAgreementId: string } } | null) => {
        const paymentAgreementId = data?.message?.paymentAgreementId;
        if (paymentAgreementId) {
          getBiLogger().report(
            myWalletNewCcWasAdded({
              paymentAgreementList: paymentAgreementId,
            }),
          );
          props.showCardAddedMessage();
          props.fetchCards();
        } else {
          getBiLogger().report(myWalletModalClosed({ modalType: ModalType.AddingCC }));
        }
      },
      theme: 'BARE',
    });
  }, []);

  return <AddPaymentMethodButtonView onClick={openAddNewModal} />;
};
